module.exports = __webpack_public_path__ + "static/media/MEX.ab67f6ef.svg";